import qs from 'query-string'
import { useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

interface Parameter {
  data: { companyId: string; include_drafts?: boolean }
}

export const getBriefs = async (data: Parameter['data']) => {
  try {
    const endpoint = qs.stringifyUrl(
      {
        url: '/briefs',
        query: {
          company_id: data.companyId,
          include_drafts: data.include_drafts,
          page_size: 100
        }
      },
      { skipNull: true, skipEmptyString: true }
    )
    const response = await axios.get(endpoint)
    return extract.data<BriefList[]>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useGetBriefs({ data }: Parameter) {
  return useQuery({
    queryKey: ['briefs', data?.companyId],
    queryFn: () => getBriefs(data)
  })
}

export default useGetBriefs
